"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledForm = exports.SaveButton = exports.MediaUploaderWrapper = exports.Label = exports.Description = exports.ContentWrapper = exports.Container = exports.CloseIcon = exports.ButtonsContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../../../Icon"));
var _palette = require("../../../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Description = exports.Description = _styledComponents["default"].p.withConfig({
  displayName: "styles__Description",
  componentId: "sc-xl7ir6-0"
})(["font-size:18px;font-family:'Lato';color:#333;padding-bottom:16px;font-size:14px;"]);
var SaveButton = exports.SaveButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__SaveButton",
  componentId: "sc-xl7ir6-1"
})(["background-color:", ";border:none;color:#fff;font-size:16px;padding:15px;border-radius:3px;letter-spacing:1px;cursor:", ";text-transform:uppercase;"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? _palette.commonPalette.ghostlyGreen : _palette.commonPalette.sgGreen;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'not-allowed' : 'pointer';
});
var CloseIcon = exports.CloseIcon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styles__CloseIcon",
  componentId: "sc-xl7ir6-2"
})(["height:16px;margin-top:5px;"]);
var StyledForm = exports.StyledForm = _styledComponents["default"].form.withConfig({
  displayName: "styles__StyledForm",
  componentId: "sc-xl7ir6-3"
})(["display:flex;flex-direction:column;"]);
var ContentWrapper = exports.ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-xl7ir6-4"
})(["flex:1;overflow-y:auto;"]);
var MediaUploaderWrapper = exports.MediaUploaderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__MediaUploaderWrapper",
  componentId: "sc-xl7ir6-5"
})(["margin-top:21px;flex:1;"]);
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-xl7ir6-6"
})(["width:100%;height:100%;overflow-y:auto;display:flex;flex-direction:column;"]);
var ButtonsContainer = exports.ButtonsContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__ButtonsContainer",
  componentId: "sc-xl7ir6-7"
})(["display:flex;justify-content:flex-start;margin-top:24px;flex-direction:row;gap:16px;"]);
var Label = exports.Label = _styledComponents["default"].p.withConfig({
  displayName: "styles__Label",
  componentId: "sc-xl7ir6-8"
})(["font-size:16px;font-family:'Lato';color:#686e6e;padding-bottom:8px;"]);
//# sourceMappingURL=styles.js.map